// extracted by mini-css-extract-plugin
module.exports = {"container":"Toggle_container__10pFC","switch":"Toggle_switch__2aqZU","slider":"Toggle_slider__1R4zV"};